import keymirror from 'keymirror';
import { request } from 'js/api/axios';
import { callApi } from '../api';
import { SCHEMAS } from 'js/api/schemas';
import { spreadApiKeys, extractApiKeys } from '../utils';

export const types = keymirror({
  ...spreadApiKeys('LIST_FAVORITE_USER_GROUPS'),
  ...spreadApiKeys('CREATE_FAVORITE_USER_GROUP'),
  ...spreadApiKeys('DELETE_FAVORITE_USER_GROUP'),
});

export function list(workspaceId, queryId = null) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.LIST_FAVORITE_USER_GROUPS, types),
        request: (_data, token, _currentWorkspaceId) =>
          request.get(`/api/workspaces/${workspaceId}/favorite-user-groups`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        schema: SCHEMAS.FAVORITE_USER_GROUP_ARRAY,
        meta: { queryId },
      },
      dispatch
    );
  };
}

export function create(workspaceId, userGroupId) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.CREATE_FAVORITE_USER_GROUP, types),
        request: (_data, token) =>
          request.post(
            `/api/workspaces/${workspaceId}/favorite-user-groups`,
            { user_group_id: userGroupId },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
      },
      dispatch
    );
  };
}

export function del(workspaceId, userGroupId) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.DELETE_FAVORITE_USER_GROUP, types),
        request: (_data, token) =>
          request.delete(
            `/api/workspaces/${workspaceId}/favorite-user-groups/${userGroupId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        data: {},
        meta: { queryId: null },
        mutators: [
          undefined,
          (action, reqData, respData, status) => ({
            ...action,
            status,
            data: respData,
            meta: {
              queryId: null,
              request: reqData,
              patch: {
                favoriteUserGroups: {
                  [userGroupId]: { is_favorited: false },
                },
              },
            },
          }),
          undefined,
        ],
      },
      dispatch
    );
  };
}
